import type { PhotoAssetCursorMeta } from './photo-assets.types'

/**
 * `getNextPageParam` for the photo asset indexes: pages start without a cursor and stop when the
 * API sends a null `next_cursor`.
 */
export const getNextPhotoAssetPageCursor = (lastPage: { meta: PhotoAssetCursorMeta }) =>
  lastPage.meta.next_cursor || undefined
